import React from 'react';

import Highspeedhybrid from './Highspeedhybrid';
import  Applifood from './Applifood';
import Applicaticase from './Applicaticase';
import Clampingstable from './Clampingstable';
import Highspeedsensiti from './Highspeedsensiti';
import Friendyconfiger from './Friendyconfiger';
// import Requstform from './Requstform';
import Jevseriesize from './Jevseriesize';



const Hybridinjectsers = () => {
  return (
    <div>
    <Highspeedhybrid />
< Applifood/>
< Applicaticase/>
< Clampingstable/>
< Highspeedsensiti/>
< Friendyconfiger/>
{/* < Requstform/> */}
< Jevseriesize/>
    </div>
  );
};

export default Hybridinjectsers;
